module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_aqua_black_short-a31dcb6b5941db21d8ce821a19b92bb9.svg";